<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-center>
        <img src="@/assets/logo.png" alt="Vuetify.js" class="mb-5">
        <blockquote>
          <!-- &#8220;First, solve the problem. Then, write the code.&#8221; -->
          <footer>
            <small>
              <p>user = {{user}}</p>
              <p>expire = {{expire}}</p>
              <!-- // <em>{{data}}</em> -->
              {{res}}
              <!-- <a @click="logout"> logout</a> -->
            </small>
          </footer>
        </blockquote>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>
<script type="text/javascript">

export default {
  data: () => ({
    res: {},
    user: '',
    expire: '',
    data: {}
  }),
  created () {
    this.user = this.$route.query.onechat_token
    this.expire = this.$route.query.expired_date
    this.logout()
  },
  methods: {
    logout () {
      // this.$Onechat.getAPI('m1', 'm2').then((res) => {
      //   console.log(res)
      //   this.res = res
      // })
      // this.res = await this.$Onechat.getAPI('m1', 'm2')
      // localStorage.clear()
      // this.$router.push('/login')
      // this.$socket.emit('leave', {room: this.token})
      // this.$socket.emit('disconnect')

      var headers = {'Authorization': 'Bearer A00faf32b63b858c280058e96888a450b53458eedbbac4710951949336c0561a53ad3c7684f20428f91def8c796dc10bf'}
      this.$http.post(process.env.APImanage + '/getprofile', {bot_id: 'Bdd232a9195ac5f11a862d5815fa2cb2d', source: this.$route.query.onechat_token}, {headers: headers}).then((response) => {
        this.res = response.body
      }, (response) => {})
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/test3.vue